module.exports = __webpack_public_path__ + "media/assets/community_index/close-button-59da4708ff3ebb3acd7c8344a1a836bd7ffa29509ebbf5dbf6b7ff46b459ef34.png";